/* eslint-disable */
import React, { useState, useEffect, useMemo, useRef } from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  Button,
  TextField,
  MenuItem,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import DescriptionIcon from "@material-ui/icons/Description";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import SearchIcon from "@material-ui/icons/Search";
import RefreshIcon from "@material-ui/icons/Refresh";
import PrintIcon from "@material-ui/icons/Print";
import CloseIcon from "@material-ui/icons/Close";
import moment from "moment";
import "moment/locale/th";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import { Label } from "reactstrap";
import TSSelect2 from "components/Forms/TSSelect2";

import { SalaryService } from "_services/salary.service";

moment.locale("th");

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3),
    fontFamily: '"Sarabun", "Tahoma", sans-serif',
    backgroundColor: "#f8fafc",
    minHeight: "100vh"
  },
  header: {
    marginBottom: theme.spacing(3),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: theme.spacing(2)
  },
  title: {
    fontWeight: "bold",
    color: "#0f172a",
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    fontSize: "1.5rem"
  },
  filterCard: {
    marginBottom: theme.spacing(3),
    backgroundColor: "#ffffff",
    borderRadius: 8,
    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
    border: "1px solid #e2e8f0",
    overflow: "visible !important",
    position: "relative",
    zIndex: 30
  },
  datetimeInputWrapper: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    zIndex: 20,
    "& .rdt": {
      width: "100%",
      position: "relative"
    },
    "& .rdtPicker": {
      position: "absolute",
      top: "calc(100% + 4px)",
      left: 0,
      zIndex: 99999,
      backgroundColor: "#ffffff",
      boxShadow: "0 10px 25px rgba(0,0,0,0.18)",
      borderRadius: "8px",
      border: "1px solid #cbd5e1",
      fontSize: "13px",
      fontFamily: '"Sarabun", "Tahoma", sans-serif',
      "& table": {
        margin: 0
      },
      "& table th, & table td": {
        fontSize: "13px",
        height: "26px",
        padding: "2px"
      },
      "& .rdtSwitch": {
        fontSize: "13px",
        fontWeight: "bold"
      }
    },
    "& input": {
      width: "100%",
      height: "38px",
      borderRadius: "4px",
      border: "1px solid #cbd5e1",
      padding: "8px 12px 8px 36px",
      fontSize: "14px",
      color: "#1e293b",
      backgroundColor: "#ffffff",
      cursor: "pointer",
      boxSizing: "border-box",
      fontFamily: '"Sarabun", "Tahoma", sans-serif',
      "&:hover": {
        borderColor: "#94a3b8"
      },
      "&:focus": {
        outline: "none",
        borderColor: "#2563eb",
        boxShadow: "0 0 0 2px rgba(37,99,235,0.1)"
      }
    }
  },
  datetimeIcon: {
    position: "absolute",
    left: "10px",
    color: "#64748b",
    zIndex: 1,
    pointerEvents: "none",
    fontSize: "1.1rem"
  },
  kpiCard: {
    borderRadius: 8,
    boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
    backgroundColor: "#ffffff",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: theme.spacing(2),
    borderLeft: "5px solid transparent",
    borderTop: "1px solid #f1f5f9",
    borderRight: "1px solid #f1f5f9",
    borderBottom: "1px solid #f1f5f9"
  },
  kpiEmployees: { borderLeftColor: "#2563eb" },
  kpiIncomes: { borderLeftColor: "#16a34a" },
  kpiOutcomes: { borderLeftColor: "#dc2626" },
  kpiNet: { borderLeftColor: "#0d9488" },
  tableContainer: {
    borderRadius: 8,
    border: "1px solid #e2e8f0",
    backgroundColor: "#ffffff",
    boxShadow: "0 1px 3px rgba(0,0,0,0.05)"
  },
  table: {
    minWidth: 1000,
    "& th, & td": {
      borderColor: "#e2e8f0"
    }
  },
  tableText: {
    fontSize: "0.8rem",
    "& th, & td": {
      fontSize: "0.8rem"
    }
  },
  sequenceCell: {
    width: "1%",
    whiteSpace: "nowrap",
    paddingLeft: 2,
    paddingRight: 2
  },
  nameCell: {
    width: "1%",
    whiteSpace: "nowrap",
    overflowWrap: "normal",
    wordBreak: "normal"
  },
  headerMain: {
    backgroundColor: "#f1f5f9",
    fontWeight: "bold",
    color: "#334155",
    fontSize: "0.8rem",
    borderBottom: "2px solid #cbd5e1"
  },
  headerIncome: {
    backgroundColor: "#ecfdf5",
    color: "#166534",
    fontWeight: "bold",
    fontSize: "0.8rem",
    borderBottom: "2px solid #a7f3d0"
  },
  headerOutcome: {
    backgroundColor: "#fef2f2",
    color: "#991b1b",
    fontWeight: "bold",
    fontSize: "0.8rem",
    borderBottom: "2px solid #fecaca"
  },
  headerNet: {
    backgroundColor: "#f0fdfa",
    color: "#115e59",
    fontWeight: "bold",
    fontSize: "0.8rem",
    borderBottom: "2px solid #99f6e4"
  },
  colSubHeaderIncome: {
    backgroundColor: "#f0fdf4",
    color: "#15803d",
    fontSize: "0.8rem",
    fontWeight: 600,
    whiteSpace: "nowrap"
  },
  colSubHeaderOutcome: {
    backgroundColor: "#fff1f2",
    color: "#be123c",
    fontSize: "0.8rem",
    fontWeight: 600,
    whiteSpace: "nowrap"
  },
  colTotalIncome: {
    backgroundColor: "#dcfce7",
    color: "#166534",
    fontWeight: "bold",
    fontSize: "0.8rem",
    whiteSpace: "nowrap"
  },
  colTotalOutcome: {
    backgroundColor: "#fee2e2",
    color: "#991b1b",
    fontWeight: "bold",
    fontSize: "0.8rem",
    whiteSpace: "nowrap"
  },
  rowItem: {
    "&:nth-of-type(even)": {
      backgroundColor: "#f8fafc"
    },
    "&:hover": {
      backgroundColor: "#f1f5f9"
    }
  },
  totalFooterRow: {
    backgroundColor: "#e2e8f0",
    fontWeight: "bold",
    "& td": {
      fontWeight: "bold",
      color: "#0f172a",
      fontSize: "0.8rem",
      borderTop: "2px solid #94a3b8"
    }
  },
  previewPaper: {
    fontFamily: '"Sarabun", "Tahoma", sans-serif',
    backgroundColor: "#f8fafc"
  },
  previewTitle: {
    borderBottom: "1px solid #e2e8f0",
    backgroundColor: "#ffffff",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: theme.spacing(2)
  },
  previewContent: {
    padding: theme.spacing(3),
    minHeight: 0
  },
  previewReport: {
    padding: theme.spacing(3),
    backgroundColor: "#ffffff",
    color: "#000000",
    minHeight: "100%",
    boxSizing: "border-box"
  },
  previewActions: {
    padding: 0,
    marginLeft: "auto",
    flexShrink: 0
  },
  printDate: {
    display: "block",
    textAlign: "right",
    marginTop: theme.spacing(1),
    fontSize: "0.6rem",
    color: "#64748b"
  }
}));

const formatReportDate = value => {
  const date = moment(value, "YYYY-MM-DD", true);
  return date.isValid() ? `${date.format("D MMMM")} ${date.year() + 543}` : "-";
};

const formatMoney = value =>
  Number(value || 0)
    .toLocaleString("th-TH", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
    .replace(/\.00$/, "");

export default function SalaryDetailedReport() {
  const classes = useStyles();

  // Current user & Finance permission check
  const currentUser = (() => {
    try {
      const u = localStorage.getItem("currentUser");
      return u ? JSON.parse(u) : null;
    } catch {
      return null;
    }
  })();

  const isFinanceUser = (() => {
    if (!currentUser) return false;
    const userDepts = Array.isArray(currentUser.userDepartment)
      ? currentUser.userDepartment
      : Array.isArray(currentUser.userView?.userDepartment)
      ? currentUser.userView.userDepartment
      : [];

    const isFinance = userDepts.some(u => {
      const depName =
        u.department?.name ||
        u.department?.Name ||
        u.department?.departmentName ||
        u.departmentName ||
        "";
      const depKey = Number(u.departmentKey);
      return (
        depKey === 102 ||
        depKey === 135 ||
        depKey === 157 ||
        depName.includes("การเงิน") ||
        depName.includes("บัญชี")
      );
    });

    const isAdmin =
      currentUser?.roles?.includes("Admin") ||
      currentUser?.userName === "madarakung" ||
      userDepts.some(u => Number(u.departmentKey) === 108);

    return isFinance || isAdmin;
  })();

  // Filter states: Start date (1st of current month) and End date (last day of current month)
  const [startDate, setStartDate] = useState(
    moment()
      .startOf("month")
      .format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment()
      .endOf("month")
      .format("YYYY-MM-DD")
  );
  const [typeGov, setTypeGov] = useState(0);
  const [typeGovList, setTypeGovList] = useState([]);
  const [search, setSearch] = useState("");

  // Loading & Data states
  const [loading, setLoading] = useState(false);
  const [rawEmployees, setRawEmployees] = useState([]);
  const [allIncomes, setAllIncomes] = useState([]);
  const [allOutcomes, setAllOutcomes] = useState([]);
  const [loadError, setLoadError] = useState("");
  const [printPreviewOpen, setPrintPreviewOpen] = useState(false);
  const requestIdRef = useRef(0);

  useEffect(() => {
    if (!isFinanceUser) return;
    let active = true;
    const loadTypeGov = async () => {
      try {
        const res = await SalaryService.getTypeGov();
        const rawData =
          res.data?.data || (Array.isArray(res.data) ? res.data : []);
        if (active && Array.isArray(rawData)) {
          setTypeGovList(
            rawData.map(t => ({
              key: Number(t.typeGovKey ?? t.TypeGovKey ?? t.key),
              name: t.name || t.Name,
              code: t.code || t.Code
            }))
          );
        }
      } catch (err) {
        console.error("Error loading typeGov list:", err);
      }
    };
    loadTypeGov();
    return () => {
      active = false;
    };
  }, [isFinanceUser]);

  useEffect(() => {
    if (isFinanceUser) {
      loadDetailedData();
    }
    return () => {
      requestIdRef.current += 1;
    };
  }, [isFinanceUser, startDate, endDate, typeGov]);

  useEffect(() => {
    if (!printPreviewOpen) return;
    document.body.classList.add("salary-report-printing");
    return () => document.body.classList.remove("salary-report-printing");
  }, [printPreviewOpen]);

  const loadDetailedData = async () => {
    const requestId = ++requestIdRef.current;
    setLoading(true);
    setLoadError("");
    try {
      const start = moment(startDate, "YYYY-MM-DD", true);
      const end = moment(endDate, "YYYY-MM-DD", true);
      if (!start.isValid() || !end.isValid() || start.isAfter(end)) {
        throw new Error(
          "กรุณาเลือกช่วงวันที่ให้ถูกต้อง โดยวันที่เริ่มต้นต้องไม่เกินวันที่สิ้นสุด"
        );
      }

      // Calculate all (calYear, calMonth) in range
      const months = [];
      let curr = start.clone().startOf("month");
      const last = end.clone().startOf("month");

      while (curr.isSameOrBefore(last)) {
        months.push({
          calYear: curr.year() + 543,
          calMonth: curr.month() + 1
        });
        curr.add(1, "month");
      }

      // Fetch all months in range in parallel
      const responses = await Promise.all(
        months.map(m =>
          SalaryService.getMonthlySummary(m.calYear, m.calMonth, typeGov)
        )
      );
      if (requestId !== requestIdRef.current) return;
      if (responses.some(res => !res.data?.success || !res.data.data)) {
        throw new Error("โหลดข้อมูลรายงานไม่ครบถ้วน กรุณาลองใหม่อีกครั้ง");
      }

      // Collect master Incomes and Outcomes
      const incomeMap = new Map();
      const outcomeMap = new Map();

      responses.forEach(res => {
        if (res.data?.success && res.data.data) {
          (res.data.data.incomes || []).forEach(inc => {
            const id = inc.incomeID ?? inc.IncomeID ?? inc.ID;
            incomeMap.set(id, {
              ID: id,
              Name: inc.incomeName ?? inc.IncomeName ?? inc.Name ?? inc.name
            });
          });
          (res.data.data.outcomes || []).forEach(out => {
            const id = out.outcomeID ?? out.OutcomeID ?? out.ID;
            outcomeMap.set(id, {
              ID: id,
              Name: out.outcomeName ?? out.OutcomeName ?? out.Name ?? out.name
            });
          });
        }
      });

      setAllIncomes(Array.from(incomeMap.values()).sort((a, b) => a.ID - b.ID));
      setAllOutcomes(
        Array.from(outcomeMap.values()).sort((a, b) => a.ID - b.ID)
      );

      // Aggregate employee items across months
      const employeeAggMap = new Map();

      responses.forEach(res => {
        if (res.data?.success && res.data.data) {
          const items = res.data.data.items || [];
          items.forEach(item => {
            const userName = item.userName;
            if (!employeeAggMap.has(userName)) {
              employeeAggMap.set(userName, {
                userName: item.userName,
                fullName: item.fullName,
                positionName: item.positionName,
                typeGovKey: item.typeGovKey,
                typeGovName: item.typeGovName,
                departmentName: item.departmentName,
                identificationID: item.identificationID,
                accountNo: item.accountNo,
                totalIncome: 0,
                totalOutcome: 0,
                netSalary: 0,
                incomeValues: {},
                outcomeValues: {}
              });
            }

            const emp = employeeAggMap.get(userName);
            emp.totalIncome += Number(item.totalIncome || 0);
            emp.totalOutcome += Number(item.totalOutcome || 0);
            emp.netSalary = emp.totalIncome - emp.totalOutcome;

            // Merge income category values
            const itemIncomes = item.incomeValues || item.IncomeValues || {};
            Object.keys(itemIncomes).forEach(id => {
              const numId = Number(id);
              emp.incomeValues[numId] =
                (emp.incomeValues[numId] || 0) + Number(itemIncomes[id] || 0);
            });

            // Merge outcome category values
            const itemOutcomes = item.outcomeValues || item.OutcomeValues || {};
            Object.keys(itemOutcomes).forEach(id => {
              const numId = Number(id);
              emp.outcomeValues[numId] =
                (emp.outcomeValues[numId] || 0) + Number(itemOutcomes[id] || 0);
            });
          });
        }
      });

      const aggregatedList = Array.from(employeeAggMap.values()).sort(
        (a, b) =>
          (a.typeGovKey || 99) - (b.typeGovKey || 99) ||
          a.fullName.localeCompare(b.fullName, "th")
      );

      setRawEmployees(aggregatedList);
    } catch (err) {
      if (requestId !== requestIdRef.current) return;
      setRawEmployees([]);
      setAllIncomes([]);
      setAllOutcomes([]);
      setLoadError(
        err.response?.data?.message ||
          err.message ||
          "ไม่สามารถโหลดรายงานได้ กรุณาลองใหม่อีกครั้ง"
      );
      console.error("Error loading detailed salary report:", err);
    } finally {
      if (requestId === requestIdRef.current) setLoading(false);
    }
  };

  // Client-side text search filter
  const filteredEmployees = useMemo(() => {
    if (!search) return rawEmployees;
    const s = search.toLowerCase();
    return rawEmployees.filter(item => {
      return (
        item.fullName?.toLowerCase().includes(s) ||
        item.userName?.toLowerCase().includes(s) ||
        item.positionName?.toLowerCase().includes(s) ||
        item.identificationID?.includes(s) ||
        item.accountNo?.includes(s)
      );
    });
  }, [rawEmployees, search]);

  // Calculate sum for each Income category across filtered employees
  const incomeCategorySums = useMemo(() => {
    const sums = {};
    allIncomes.forEach(inc => {
      sums[inc.ID] = filteredEmployees.reduce((acc, row) => {
        return acc + (Number(row.incomeValues?.[inc.ID]) || 0);
      }, 0);
    });
    return sums;
  }, [allIncomes, filteredEmployees]);

  // Calculate sum for each Outcome category across filtered employees
  const outcomeCategorySums = useMemo(() => {
    const sums = {};
    allOutcomes.forEach(out => {
      sums[out.ID] = filteredEmployees.reduce((acc, row) => {
        return acc + (Number(row.outcomeValues?.[out.ID]) || 0);
      }, 0);
    });
    return sums;
  }, [allOutcomes, filteredEmployees]);

  const visibleIncomes = useMemo(
    () => allIncomes.filter(inc => (incomeCategorySums[inc.ID] || 0) !== 0),
    [allIncomes, incomeCategorySums]
  );
  const visibleOutcomes = useMemo(
    () => allOutcomes.filter(out => (outcomeCategorySums[out.ID] || 0) !== 0),
    [allOutcomes, outcomeCategorySums]
  );

  // Totals for KPI Cards & Footer
  const grandTotalEmployees = filteredEmployees.length;
  const grandTotalIncome = useMemo(() => {
    return filteredEmployees.reduce(
      (acc, row) => acc + (row.totalIncome || 0),
      0
    );
  }, [filteredEmployees]);
  const grandTotalOutcome = useMemo(() => {
    return filteredEmployees.reduce(
      (acc, row) => acc + (row.totalOutcome || 0),
      0
    );
  }, [filteredEmployees]);
  const grandTotalNet = grandTotalIncome - grandTotalOutcome;

  // Open the browser print dialog only after confirmation in the preview.
  const handlePrint = () => {
    window.print();
  };

  const getPersonnelGroupName = key => {
    if (!key || key === 0) return "ทั้งหมดทุกกลุ่ม";
    const found = typeGovList.find(t => t.key === key);
    return found ? found.name : "ทั้งหมด";
  };

  const showPersonnelColumn = typeGov === 0;
  const employeeColumnCount = showPersonnelColumn ? 3 : 2;

  // Reduce the calculated diagonal heading height by 40%.
  const printHeaderHeight = `${0.6 *
    Math.max(
      14,
      ...[
        ...visibleIncomes.map(inc => inc.Name || inc.name || ""),
        ...visibleOutcomes.map(out => out.Name || out.name || ""),
        "รวมรายได้",
        "รวมรายจ่าย",
        "เงินเดือนสุทธิ"
      ].map(name => Array.from(name).length * 0.75 + 3)
    )}em`;

  const renderDetailedTable = () => (
    <Card variant="outlined" className="salary-report-table-card">
      <CardContent style={{ padding: 0 }}>
        {loading ? (
          <Box py={8} textAlign="center">
            <CircularProgress size={36} />
            <Typography style={{ marginTop: 12, color: "#64748b" }}>
              กำลังประมวลผลรายงานเงินเดือนโดยละเอียด...
            </Typography>
          </Box>
        ) : (
          <TableContainer
            component={Paper}
            elevation={0}
            className="salary-report-table-container"
          >
            <Table
              size="small"
              className={`${classes.tableText} salary-report-table`}
              aria-label="รายงานเงินเดือนโดยละเอียด"
              style={{ "--salary-report-header-height": printHeaderHeight }}
            >
              <TableHead>
                {/* Header Row 1: Section Spans */}
                <TableRow>
                  <TableCell
                    rowSpan={2}
                    align="center"
                    className={`${classes.headerMain} ${classes.sequenceCell} salary-report-sequence`}
                  >
                    ลำดับ
                  </TableCell>
                  <TableCell
                    rowSpan={2}
                    className={`${classes.headerMain} ${classes.nameCell} salary-report-name`}
                  >
                    ชื่อ - สกุล
                  </TableCell>
                  {showPersonnelColumn && (
                    <TableCell
                      rowSpan={2}
                      className={classes.headerMain}
                      style={{ minWidth: 100 }}
                    >
                      กลุ่มบุคลากร
                    </TableCell>
                  )}

                  {/* Incomes Group Header */}
                  <TableCell
                    colSpan={visibleIncomes.length + 1}
                    align="center"
                    className={`${classes.headerIncome} header-inc`}
                  >
                    หมวดรายได้ (Incomes)
                  </TableCell>

                  {/* Outcomes Group Header */}
                  <TableCell
                    colSpan={visibleOutcomes.length + 1}
                    align="center"
                    className={`${classes.headerOutcome} header-out`}
                  >
                    หมวดรายการหัก (Deductions)
                  </TableCell>

                  {/* Net Salary Header */}
                  <TableCell
                    rowSpan={2}
                    align="right"
                    className={`${classes.headerNet} col-net-tot salary-report-rotated-header`}
                    style={{ minWidth: 95 }}
                  >
                    <span className="salary-report-heading-wrap">
                      <span className="salary-report-heading-label">
                        เงินเดือนสุทธิ
                      </span>
                    </span>
                  </TableCell>
                </TableRow>

                {/* Header Row 2: Category Names */}
                <TableRow>
                  {/* Dynamic Income Category Columns */}
                  {visibleIncomes.map(inc => (
                    <TableCell
                      key={`inc-col-${inc.ID}`}
                      align="right"
                      className={`${classes.colSubHeaderIncome} salary-report-rotated-header`}
                    >
                      <span className="salary-report-heading-wrap">
                        <span className="salary-report-heading-label">
                          {inc.Name || inc.name}
                        </span>
                      </span>
                    </TableCell>
                  ))}
                  <TableCell
                    align="right"
                    className={`${classes.colTotalIncome} col-inc-tot salary-report-rotated-header`}
                  >
                    <span className="salary-report-heading-wrap">
                      <span className="salary-report-heading-label">
                        รวมรายได้
                      </span>
                    </span>
                  </TableCell>

                  {/* Dynamic Outcome Category Columns */}
                  {visibleOutcomes.map(out => (
                    <TableCell
                      key={`out-col-${out.ID}`}
                      align="right"
                      className={`${classes.colSubHeaderOutcome} salary-report-rotated-header`}
                    >
                      <span className="salary-report-heading-wrap">
                        <span className="salary-report-heading-label">
                          {out.Name || out.name}
                        </span>
                      </span>
                    </TableCell>
                  ))}
                  <TableCell
                    align="right"
                    className={`${classes.colTotalOutcome} col-out-tot salary-report-rotated-header`}
                  >
                    <span className="salary-report-heading-wrap">
                      <span className="salary-report-heading-label">
                        รวมรายจ่าย
                      </span>
                    </span>
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {filteredEmployees.length === 0 ? (
                  <TableRow>
                    <TableCell
                      colSpan={
                        visibleIncomes.length +
                        visibleOutcomes.length +
                        employeeColumnCount +
                        3
                      }
                      align="center"
                      style={{ padding: 48, color: "#64748b" }}
                    >
                      {loadError ||
                        "ไม่พบข้อมูลเงินเดือนตามช่วงวันที่และเงื่อนไขที่เลือก"}
                    </TableCell>
                  </TableRow>
                ) : (
                  filteredEmployees.map((row, idx) => (
                    <TableRow key={row.userName} className={classes.rowItem}>
                      <TableCell
                        align="center"
                        className={`${classes.sequenceCell} salary-report-sequence`}
                        style={{ color: "#64748b" }}
                      >
                        {idx + 1}
                      </TableCell>
                      <TableCell
                        className={`${classes.nameCell} salary-report-name`}
                        style={{ fontWeight: 600, color: "#1e293b" }}
                      >
                        {row.fullName}
                      </TableCell>
                      {showPersonnelColumn && (
                        <TableCell
                          style={{ fontSize: "0.8rem", color: "#475569" }}
                        >
                          {row.typeGovName || "-"}
                        </TableCell>
                      )}

                      {/* Income Values */}
                      {visibleIncomes.map(inc => {
                        const val = Number(row.incomeValues?.[inc.ID] || 0);
                        return (
                          <TableCell
                            key={`val-inc-${row.userName}-${inc.ID}`}
                            align="right"
                          >
                            {val !== 0 ? formatMoney(val) : "-"}
                          </TableCell>
                        );
                      })}

                      {/* Total Income for row */}
                      <TableCell
                        align="right"
                        className="col-inc-tot"
                        style={{
                          fontWeight: "bold",
                          color: "#166534",
                          backgroundColor: "#f0fdf4"
                        }}
                      >
                        {formatMoney(row.totalIncome || 0)}
                      </TableCell>

                      {/* Outcome Values */}
                      {visibleOutcomes.map(out => {
                        const val = Number(row.outcomeValues?.[out.ID] || 0);
                        return (
                          <TableCell
                            key={`val-out-${row.userName}-${out.ID}`}
                            align="right"
                          >
                            {val !== 0 ? formatMoney(val) : "-"}
                          </TableCell>
                        );
                      })}

                      {/* Total Outcome for row */}
                      <TableCell
                        align="right"
                        className="col-out-tot"
                        style={{
                          fontWeight: "bold",
                          color: "#991b1b",
                          backgroundColor: "#fef2f2"
                        }}
                      >
                        {formatMoney(row.totalOutcome || 0)}
                      </TableCell>

                      {/* Net Salary for row */}
                      <TableCell
                        align="right"
                        className="col-net-tot"
                        style={{
                          fontWeight: "bold",
                          color: "#0f766e",
                          backgroundColor: "#f0fdfa"
                        }}
                      >
                        {formatMoney(row.netSalary || 0)}
                      </TableCell>
                    </TableRow>
                  ))
                )}

                {/* Grand Total Footer Row */}
                {filteredEmployees.length > 0 && (
                  <TableRow className={`${classes.totalFooterRow} footer-row`}>
                    <TableCell colSpan={employeeColumnCount} align="center">
                      รวมทั้งสิ้น ({grandTotalEmployees} คน)
                    </TableCell>

                    {/* Sums for each income category */}
                    {visibleIncomes.map(inc => {
                      const sum = incomeCategorySums[inc.ID] || 0;
                      return (
                        <TableCell key={`tot-inc-${inc.ID}`} align="right">
                          {formatMoney(sum)}
                        </TableCell>
                      );
                    })}

                    {/* Grand Total Income */}
                    <TableCell
                      align="right"
                      className="col-inc-tot"
                      style={{ color: "#166534", backgroundColor: "#dcfce7" }}
                    >
                      {formatMoney(grandTotalIncome)}
                    </TableCell>

                    {/* Sums for each outcome category */}
                    {visibleOutcomes.map(out => {
                      const sum = outcomeCategorySums[out.ID] || 0;
                      return (
                        <TableCell key={`tot-out-${out.ID}`} align="right">
                          {formatMoney(sum)}
                        </TableCell>
                      );
                    })}

                    {/* Grand Total Outcome */}
                    <TableCell
                      align="right"
                      className="col-out-tot"
                      style={{ color: "#991b1b", backgroundColor: "#fee2e2" }}
                    >
                      {formatMoney(grandTotalOutcome)}
                    </TableCell>

                    {/* Grand Total Net */}
                    <TableCell
                      align="right"
                      className="col-net-tot"
                      style={{ color: "#0f766e", backgroundColor: "#ccfbf1" }}
                    >
                      {formatMoney(grandTotalNet)}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </CardContent>
    </Card>
  );

  if (!isFinanceUser) {
    return (
      <div className={classes.root}>
        <Paper
          style={{
            padding: 48,
            textAlign: "center",
            backgroundColor: "#fff",
            borderRadius: 8
          }}
        >
          <MonetizationOnIcon
            style={{ fontSize: 64, color: "#f59e0b", marginBottom: 16 }}
          />
          <Typography
            variant="h5"
            style={{ fontWeight: "bold", color: "#1e293b" }}
            gutterBottom
          >
            ขออภัย คุณไม่มีสิทธิ์เข้าถึงรายงานเงินเดือนโดยละเอียด
          </Typography>
          <Typography
            variant="body1"
            color="textSecondary"
            style={{ maxWidth: 600, margin: "0 auto 24px auto" }}
          >
            ระบบนี้สงวนสิทธิ์เฉพาะเจ้าหน้าที่กลุ่มงานการเงินและบัญชีเท่านั้น
          </Typography>
        </Paper>
      </div>
    );
  }

  return (
    <div className={classes.root}>
      {printPreviewOpen && (
        <style>{`
          @media print {
            @page {
              size: A4 landscape;
              margin: 6mm;
            }
            html, body.salary-report-printing {
              height: auto !important;
              min-width: 0 !important;
              overflow: visible !important;
              margin: 0 !important;
              padding: 0 !important;
              background: #ffffff !important;
            }
            body.salary-report-printing > :not(.salary-report-print-dialog) {
              display: none !important;
            }
            .salary-report-print-dialog {
              position: static !important;
              height: auto !important;
              overflow: visible !important;
            }
            .salary-report-print-dialog .MuiBackdrop-root,
            .salary-report-print-dialog .salary-report-print-controls {
              display: none !important;
            }
            .salary-report-print-dialog .MuiDialog-container,
            .salary-report-print-dialog .MuiDialog-paper,
            .salary-report-print-dialog .salary-report-preview-content {
              display: block !important;
              position: static !important;
              width: 100% !important;
              height: auto !important;
              min-height: 0 !important;
              max-height: none !important;
              max-width: none !important;
              margin: 0 !important;
              padding: 0 !important;
              overflow: visible !important;
              transform: none !important;
              box-shadow: none !important;
              border: 0 !important;
              border-radius: 0 !important;
            }
            .salary-report-document {
              width: 100% !important;
              box-sizing: border-box !important;
              padding: 0 1mm !important;
              font-size: 8pt !important;
            }
            .salary-report-document .salary-report-table-card,
            .salary-report-document .salary-report-table-container {
              border: 0 !important;
              border-radius: 0 !important;
              overflow: visible !important;
              box-shadow: none !important;
            }
            .salary-report-document .salary-report-table {
              width: 100% !important;
              box-sizing: border-box !important;
              min-width: 0 !important;
              max-width: 100% !important;
              table-layout: auto !important;
              border-collapse: collapse !important;
            }
            .salary-report-document .salary-report-table thead {
              display: table-header-group !important;
              break-inside: avoid !important;
            }
            .salary-report-document .salary-report-table tr,
            .salary-report-document .salary-report-print-date {
              break-inside: avoid !important;
              page-break-inside: avoid !important;
            }
            .salary-report-document .salary-report-print-date {
              font-size: 6pt !important;
            }
            .salary-report-document .salary-report-table th,
            .salary-report-document .salary-report-table td {
              width: auto !important;
              min-width: 0 !important;
              border: 1px solid #777 !important;
              padding: 1px !important;
              font-size: 0.6rem !important;
              line-height: 1.2 !important;
              white-space: normal !important;
              overflow-wrap: anywhere !important;
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
            }
            .salary-report-document .salary-report-table td.MuiTableCell-alignRight {
              white-space: nowrap !important;
              overflow-wrap: normal !important;
              word-break: normal !important;
              font-variant-numeric: tabular-nums;
            }
            .salary-report-document .salary-report-table .salary-report-name {
              width: 1% !important;
              white-space: nowrap !important;
              overflow-wrap: normal !important;
              word-break: normal !important;
            }
            .salary-report-document .salary-report-table .salary-report-rotated-header {
              height: var(--salary-report-header-height) !important;
              vertical-align: bottom !important;
              overflow: visible !important;
            }
            .salary-report-heading-wrap {
              display: block;
              position: relative;
              width: 0;
              height: var(--salary-report-header-height);
              margin: 0 auto;
            }
            .salary-report-heading-label {
              position: absolute;
              left: 0;
              bottom: 3px;
              white-space: nowrap;
              transform: rotate(-65deg);
              transform-origin: left bottom;
            }
            .salary-report-document .salary-report-table .salary-report-sequence {
              width: 3em !important;
              white-space: nowrap !important;
              padding-left: 2px !important;
              padding-right: 2px !important;
            }
          }
        `}</style>
      )}

      {/* Screen Top Header (Hidden on print) */}
      <div className={`${classes.header} no-print`}>
        <div>
          <Typography variant="h5" className={classes.title}>
            <DescriptionIcon style={{ color: "#2563eb", fontSize: "1.8rem" }} />
            รายงานเงินเดือนโดยละเอียด
          </Typography>
          <Typography
            variant="body2"
            color="textSecondary"
            style={{ marginTop: 4 }}
          >
            แสดงข้อมูลเงินเดือน รายรับ-รายจ่ายทุกหมวดหมู่ และยอดสุทธิรายบุคคล
            (พิมพ์ A4 แนวนอน)
          </Typography>
        </div>

        {/* Action Button: Print */}
        <Box display="flex" gap={1}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<PrintIcon />}
            onClick={() => setPrintPreviewOpen(true)}
            disabled={loading || !!loadError || filteredEmployees.length === 0}
            style={{
              backgroundColor: "#0d9488",
              color: "#ffffff",
              fontWeight: "bold",
              borderRadius: 6,
              boxShadow: "0 2px 4px rgba(13,148,136,0.3)"
            }}
          >
            พิมพ์รายงาน (A4 แนวนอน)
          </Button>
        </Box>
      </div>

      {/* Screen Filter Bar Card (Hidden on print) */}
      <Card variant="outlined" className={`${classes.filterCard} no-print`}>
        <CardContent style={{ padding: "16px 20px" }}>
          <Grid container spacing={2} alignItems="center">
            {/* Filter: Start Date */}
            <Grid item xs={12} sm={6} md={3} style={{ position: "relative", zIndex: 30 }}>
              <Label
                style={{
                  fontWeight: 500,
                  fontSize: "14px",
                  color: "#334155",
                  marginBottom: 6,
                  display: "inline-block"
                }}
              >
                ตั้งแต่วันที่
              </Label>
              <div className={classes.datetimeInputWrapper}>
                <i className={`far fa-calendar-alt ${classes.datetimeIcon}`} />
                <Datetime
                  value={moment(startDate).isValid() ? moment(startDate) : null}
                  renderYear={function(props, year) {
                    return <td {...props}>{year + 543}</td>;
                  }}
                  inputProps={{
                    placeholder: "วันที่เริ่มต้น"
                  }}
                  closeOnSelect={true}
                  closeOnTab={true}
                  dateFormat="D MMMM BBBB"
                  timeFormat={false}
                  onChange={e => {
                    if (moment.isMoment(e)) {
                      setStartDate(e.format("YYYY-MM-DD"));
                    } else if (typeof e === "string") {
                      setStartDate(e);
                    }
                  }}
                />
              </div>
            </Grid>

            {/* Filter: End Date */}
            <Grid item xs={12} sm={6} md={3} style={{ position: "relative", zIndex: 25 }}>
              <Label
                style={{
                  fontWeight: 500,
                  fontSize: "14px",
                  color: "#334155",
                  marginBottom: 6,
                  display: "inline-block"
                }}
              >
                ถึงวันที่
              </Label>
              <div className={classes.datetimeInputWrapper}>
                <i className={`far fa-calendar-alt ${classes.datetimeIcon}`} />
                <Datetime
                  value={moment(endDate).isValid() ? moment(endDate) : null}
                  renderYear={function(props, year) {
                    return <td {...props}>{year + 543}</td>;
                  }}
                  inputProps={{
                    placeholder: "ถึงวันที่"
                  }}
                  closeOnSelect={true}
                  closeOnTab={true}
                  dateFormat="D MMMM BBBB"
                  timeFormat={false}
                  onChange={e => {
                    if (moment.isMoment(e)) {
                      setEndDate(e.format("YYYY-MM-DD"));
                    } else if (typeof e === "string") {
                      setEndDate(e);
                    }
                  }}
                />
              </div>
            </Grid>

            {/* Filter: Personnel Type (กลุ่มบุคลากร) */}
            <Grid item xs={12} sm={6} md={3} style={{ position: "relative", zIndex: 20 }}>
              <TSSelect2
                label="กลุ่มบุคลากร"
                options={[
                  { value: 0, label: "ทั้งหมดทุกกลุ่ม" },
                  ...typeGovList.map(t => ({ value: t.key, label: t.name }))
                ]}
                value={typeGov}
                onChange={opt => setTypeGov(opt ? Number(opt.value) : 0)}
                isClearable={false}
              />
            </Grid>

            {/* Search Input */}
            <Grid item xs={12} sm={6} md={3} style={{ position: "relative", zIndex: 10 }}>
              <Typography
                variant="caption"
                style={{
                  fontWeight: "bold",
                  color: "#475569",
                  marginBottom: 4,
                  display: "block"
                }}
              >
                ค้นหา
              </Typography>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                placeholder="ชื่อ-สกุล, ตำแหน่ง, เลขบัญชี..."
                value={search}
                onChange={e => setSearch(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon color="action" fontSize="small" />
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Screen Dashboard KPI Stat Cards (Hidden on print) */}
      <Grid
        container
        spacing={2}
        style={{ marginBottom: 24 }}
        className="no-print"
      >
        <Grid item xs={12} sm={6} md={3}>
          <Card className={`${classes.kpiCard} ${classes.kpiEmployees}`}>
            <Typography
              variant="caption"
              style={{ color: "#64748b", fontWeight: 600 }}
            >
              จำนวนบุคลากร
            </Typography>
            <Typography
              variant="h5"
              style={{ fontWeight: "bold", color: "#1d4ed8", marginTop: 4 }}
            >
              {grandTotalEmployees.toLocaleString()} คน
            </Typography>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Card className={`${classes.kpiCard} ${classes.kpiIncomes}`}>
            <Typography
              variant="caption"
              style={{ color: "#64748b", fontWeight: 600 }}
            >
              รวมรายได้ทั้งหมด (Gross)
            </Typography>
            <Typography
              variant="h5"
              style={{ fontWeight: "bold", color: "#15803d", marginTop: 4 }}
            >
              {formatMoney(grandTotalIncome)} บาท
            </Typography>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Card className={`${classes.kpiCard} ${classes.kpiOutcomes}`}>
            <Typography
              variant="caption"
              style={{ color: "#64748b", fontWeight: 600 }}
            >
              รวมรายการหักทั้งหมด (Deductions)
            </Typography>
            <Typography
              variant="h5"
              style={{ fontWeight: "bold", color: "#b91c1c", marginTop: 4 }}
            >
              {formatMoney(grandTotalOutcome)} บาท
            </Typography>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Card className={`${classes.kpiCard} ${classes.kpiNet}`}>
            <Typography
              variant="caption"
              style={{ color: "#64748b", fontWeight: 600 }}
            >
              ยอดจ่ายสุทธิ (Net Payable)
            </Typography>
            <Typography
              variant="h5"
              style={{ fontWeight: "bold", color: "#0f766e", marginTop: 4 }}
            >
              {formatMoney(grandTotalNet)} บาท
            </Typography>
          </Card>
        </Grid>
      </Grid>

      {renderDetailedTable()}

      <Dialog
        fullScreen
        open={printPreviewOpen}
        onClose={() => setPrintPreviewOpen(false)}
        aria-labelledby="salary-report-preview-title"
        className="salary-report-print-dialog"
        classes={{ paper: classes.previewPaper }}
      >
        <DialogTitle
          disableTypography
          id="salary-report-preview-title"
          className={`${classes.previewTitle} salary-report-print-controls`}
        >
          <Typography component="h2" variant="h6">
            ตัวอย่างก่อนพิมพ์รายงานเงินเดือนโดยละเอียด
          </Typography>
          <DialogActions
            className={`${classes.previewActions} salary-report-print-controls`}
          >
            <Button
              onClick={() => setPrintPreviewOpen(false)}
              variant="outlined"
              startIcon={<CloseIcon />}
            >
              ปิด
            </Button>
            <Button
              onClick={handlePrint}
              variant="contained"
              color="primary"
              startIcon={<PrintIcon />}
              disabled={
                loading || !!loadError || filteredEmployees.length === 0
              }
            >
              ยืนยันพิมพ์รายงาน
            </Button>
          </DialogActions>
        </DialogTitle>
        <DialogContent
          className={`${classes.previewContent} salary-report-preview-content`}
        >
          <div className={`${classes.previewReport} salary-report-document`}>
            <div className="salary-report-header">
              <div style={{ textAlign: "center", marginBottom: 8 }}>
                <Typography
                  variant="h6"
                  style={{ fontWeight: "bold", fontSize: "14pt" }}
                >
                  โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง
                </Typography>
                <Typography
                  variant="subtitle1"
                  style={{ fontWeight: "bold", fontSize: "11pt" }}
                >
                  รายงานสรุปเงินเดือนและค่าตอบแทนโดยละเอียด
                </Typography>
                <Typography
                  variant="body2"
                  style={{ fontSize: "8.5pt", color: "#333", marginTop: 2 }}
                >
                  ประจำวันที่ {formatReportDate(startDate)} ถึงวันที่{" "}
                  {formatReportDate(endDate)}
                </Typography>
                {typeGov > 0 && (
                  <Typography variant="body2" style={{ marginTop: 4 }}>
                    กลุ่มบุคลากร: {getPersonnelGroupName(typeGov)}
                  </Typography>
                )}
                {search.trim() && (
                  <Typography variant="body2" style={{ marginTop: 4 }}>
                    คำค้นหา: {search.trim()}
                  </Typography>
                )}
              </div>

              {/* Print Summary Strip */}
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 8,
                  justifyContent: "space-between",
                  backgroundColor: "#f8fafc",
                  border: "1px solid #94a3b8",
                  padding: "4px 10px",
                  fontSize: "8pt",
                  marginBottom: 6,
                  fontWeight: "bold"
                }}
              >
                <span>จำนวนบุคลากร: {grandTotalEmployees} คน</span>
                <span>
                  รวมรายได้ทั้งหมด: {formatMoney(grandTotalIncome)} บาท
                </span>
                <span>
                  รวมรายการหักทั้งหมด: {formatMoney(grandTotalOutcome)} บาท
                </span>
                <span style={{ color: "#0f766e" }}>
                  เงินเดือนสุทธิ: {formatMoney(grandTotalNet)} บาท
                </span>
              </div>
            </div>

            {renderDetailedTable()}
            <Typography
              component="div"
              variant="caption"
              className={`${classes.printDate} salary-report-print-date`}
            >
              วันที่พิมพ์: {formatReportDate(moment().format("YYYY-MM-DD"))}{" "}
              {moment().format("HH:mm")} น.
            </Typography>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
